import React from 'react';
import MuiAppBar from '@mui/material/AppBar';
import MuiToolbar from '@mui/material/Toolbar';
export const AppBar = ({ position = 'fixed', children, className = '', disableGutters = false, _toolbarSx, _sx, elevation = 0, dataTestId, }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(MuiAppBar, { sx: _sx, variant: "outlined", position: position, className: className, elevation: elevation, "data-testid": dataTestId },
            React.createElement(MuiToolbar, { disableGutters: disableGutters, sx: _toolbarSx }, children)),
        React.createElement(MuiToolbar, null)));
};
